import React from "react";
import Nav from "./Nav";
export default function Header() {
  return (
    <header className="ui-header">
      <Nav />
    </header>
  );
}
